import { graphqlClient } from "../../../client";
import mutationDocument from "./deleteMemberAddressesMutation.graphql";
import type {
  ContactTypeExtensionAddressesArgs,
  InputMemberAddressType,
  MemberType,
  Mutations,
  MutationsDeleteMemberAddressesArgs,
} from "@/core/api/graphql/types";

export async function deleteMemberAddresses(
  addresses: InputMemberAddressType[],
  memberId: string,
  addressQueryPayload?: ContactTypeExtensionAddressesArgs,
): Promise<MemberType> {
  const { data } = await graphqlClient.mutate<
    Required<Pick<Mutations, "deleteMemberAddressesExtension">>,
    MutationsDeleteMemberAddressesArgs
  >({
    mutation: mutationDocument,
    variables: {
      command: {
        memberId,
        addresses,
      },
      ...addressQueryPayload,
    },
  });
  return data!.deleteMemberAddressesExtension;
}
